import { URI } from '~/types/adamTypes';
import { getServices } from '~/db/services';
import type { NomadDB } from '~/db/NomadDB';

export const getExportAssessmentsPromises = async (
  db: NomadDB,
  nomadFetch: Function
): Promise<void> => {
  const { assessmentsService } = getServices(db);
  const assessments = await assessmentsService.findWhere({ id: '' });
  const chunkSize = 3500;

  const chunks = [];

  for (let i = 0; i < assessments.length; i += chunkSize) {
    chunks.push(assessments.slice(i, i + chunkSize));
  }

  const getChunksPromise = async (chunk): Promise<void> => {
    await nomadFetch(URI.MultiAssessments, {
      method: 'POST',
      body: chunk,
    });
  };

  const getPromises = (): Promise<void>[] => {
    const promises = [];
    chunks.forEach((chunk) => {
      promises.push(getChunksPromise(chunk));
    });
    return promises;
  };
  const promises = getPromises();
  if (promises.length) {
    await Promise.all(promises);
  }
};
